// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"Tabs_tabsWrapper__3vdUr","tabsItem":"Tabs_tabsItem__W4Pcr","active":"Tabs_active__uGUKx","label":"Tabs_label__TMlwy"};